module.exports = __webpack_public_path__ + "img/bg-erroe-msg.77d61caa.svg";